/*
 * Embroidery is a €50 add-on to a blazer, sold as its own cart line (the
 * "Embroidery" product). On its own it could be stocked up with +/- and left
 * in the cart with no blazer at all. This keeps it tied to the blazers:
 *
 *   - Its quantity always equals the number of blazers whose line says
 *     "Embroidery: Requested ..." - remove the blazer and the embroidery goes
 *     with it, add a second one of that blazer and a second embroidery follows.
 *   - Remove on the Embroidery line cancels embroidery: the line goes, and the
 *     blazers' "Embroidery" note is taken off so the order stays consistent.
 *
 * It runs after every cart change anywhere on the site, and once on page load
 * to tidy carts filled before this existed.
 */
(function () {
  var VARIANT_ID = '58657484865868';
  var SOURCE = 'embroidery-sync';
  var busy = false;
  var again = false;

  function isEmbroidery(item) {
    return String(item.variant_id) === VARIANT_ID;
  }

  function isRequested(item) {
    var value = item.properties && item.properties.Embroidery;
    return !!value && value !== 'Not requested';
  }

  function sum(items) {
    return items.reduce(function (total, item) { return total + item.quantity; }, 0);
  }

  function sectionIds() {
    return Array.prototype.map.call(
      document.querySelectorAll('cart-items-component'),
      function (el) { return el.dataset.sectionId; }
    ).filter(Boolean);
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); });
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) { return res.json(); });
  }

  // Redraws the cart drawer / cart page and the cart count with the theme's
  // own cart:update listeners - the same way mto-customizer.js does.
  function redraw(result) {
    if (!result || result.status || !result.sections) return;
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: result,
        sourceId: VARIANT_ID,
        data: { source: SOURCE, sections: result.sections, itemCount: result.item_count }
      }
    }));
  }

  function withSections(payload) {
    var ids = sectionIds();
    if (ids.length) payload.sections = ids.join(',');
    return payload;
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    getCart()
      .then(function (cart) {
        var lines = cart.items.filter(isEmbroidery);
        var have = sum(lines);
        var want = sum(cart.items.filter(isRequested));
        if (have === want) return;

        if (!lines.length) {
          return post('/cart/add.js', withSections({ items: [{ id: Number(VARIANT_ID), quantity: want }] }))
            .then(function () { return post('/cart/update.js', withSections({ updates: {} })); })
            .then(redraw);
        }
        // Everything on the first Embroidery line, any extra lines emptied.
        var updates = {};
        lines.forEach(function (line, index) { updates[line.key] = index === 0 ? want : 0; });
        return post('/cart/update.js', withSections({ updates: updates })).then(redraw);
      })
      .catch(function (err) { console.error('Embroidery sync failed', err); })
      .then(function () {
        busy = false;
        if (again) { again = false; sync(); }
      });
  }

  // Remove on the Embroidery line = no embroidery on any blazer. Handled here
  // instead of by the theme, which would only drop the line and let the sync
  // above put it straight back.
  function cancelEmbroidery() {
    busy = true;
    return getCart()
      .then(function (cart) {
        var chain = Promise.resolve();
        cart.items.filter(isRequested).forEach(function (item) {
          // Shopify merges properties on change, so leaving the key out keeps
          // it; an empty value is what clears it (blank properties are not
          // shown in the cart or at checkout).
          var properties = {};
          Object.keys(item.properties || {}).forEach(function (key) {
            properties[key] = key === 'Embroidery' ? '' : item.properties[key];
          });
          chain = chain.then(function () {
            return post('/cart/change.js', { id: item.key, quantity: item.quantity, properties: properties });
          });
        });
        return chain;
      })
      .then(getCart)
      .then(function (cart) {
        var updates = {};
        cart.items.filter(isEmbroidery).forEach(function (line) { updates[line.key] = 0; });
        return post('/cart/update.js', withSections({ updates: updates }));
      })
      .then(redraw)
      .catch(function (err) { console.error('Removing embroidery failed', err); })
      .then(function () { busy = false; });
  }

  window.addEventListener('click', function (event) {
    var button = event.target instanceof Element &&
      event.target.closest('.cart-items__table-row--addon .cart-items__remove');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var row = button.closest('.cart-items__table-row');
    if (row) row.style.opacity = '0.4';
    cancelEmbroidery();
  }, true);

  document.addEventListener('cart:update', function (event) {
    var data = event.detail && event.detail.data;
    if (data && data.source === SOURCE) return;
    // Let the change that fired this settle first (the blazer + embroidery
    // add is two requests).
    setTimeout(sync, 300);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
